import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_2 = { style: {"width":"250px"} }
const _hoisted_3 = {
  key: 0,
  class: "text-subtitle-2 text-grey"
}
const _hoisted_4 = { style: {"width":"200px"} }
const _hoisted_5 = { key: 0 }

import { BGOperationInfo, BGOperationsService } from '@prodcard/core'
import { onBeforeUnmount } from 'vue'
import { ref, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VBgOperations',
  props: {
    bgOperationsService: {}
  },
  setup(__props: any) {

const props = __props;


const operations: Ref<BGOperationInfo[]> = ref([])

const findExistedOpId = (op: BGOperationInfo): number | undefined => {
  const existedOpId = operations.value.findIndex(existed => existed.id === op.id)
  if (existedOpId !== -1) {
    return existedOpId
  } else {
    return
  }
}

const startWatcher = props.bgOperationsService.operationStarted.subscribe(op => {
  const existedOpId = findExistedOpId(op)
  if (existedOpId === undefined) {
    operations.value.push(op)
  }
})

const changeWatcher = props.bgOperationsService.statusChanged.subscribe(op => {
  const existedOpId = findExistedOpId(op)
  if (existedOpId !== undefined) {
    operations.value[existedOpId] = op
  } else {
    operations.value.push(op)
  }
})

const finishWatcher = props.bgOperationsService.operationFinished.subscribe(op => {
  const existedOpId = findExistedOpId(op)
  if (existedOpId !== undefined) {
    operations.value.splice(existedOpId, 1)
  }
})

const cancelWatcher = props.bgOperationsService.operationCanceled.subscribe(op => {
  const existedOpId = findExistedOpId(op)
  if (existedOpId !== undefined) {
    operations.value.splice(existedOpId, 1)
  }
})

onBeforeUnmount(() => {
  props.bgOperationsService.operationStarted.unsubscribe(startWatcher)
  props.bgOperationsService.statusChanged.unsubscribe(changeWatcher)
  props.bgOperationsService.operationFinished.unsubscribe(finishWatcher)
  props.bgOperationsService.operationCanceled.unsubscribe(cancelWatcher)
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (operations.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operations.value.filter(op => op.foreground), (operation) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: operation.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(operation.title), 1),
                (operation.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(operation.subtitle), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_progress_linear, {
                  modelValue: operation.progress,
                  "onUpdate:modelValue": ($event: any) => ((operation.progress) = $event),
                  color: "primary"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({ color: "primary" }, props, {
              variant: 'plain',
              width: 50,
              rounded: true
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  loading: true,
                  variant: 'plain'
                })
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            (operations.value.filter(op => !op.foreground).length > 0)
              ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operations.value.filter(op => !op.foreground), (operation) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: operation.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("p", null, _toDisplayString(operation.title), 1),
                            (operation.subtitle)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(operation.subtitle), 1))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_progress_linear, {
                              "model-value": ((operation.progress ?? 0) / (operation.totalSteps ?? 100)) * 100,
                              color: "primary"
                            }, null, 8, ["model-value"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})